export const STORAGE_SESSION_ID_KEY = 'sessionId';

export function generateRandomId(): string {
	return Math.random().toString(36).slice(2, 20);
}

export function generateRandomGUID(): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function initializeSessionId({ storageSessionIdKey = STORAGE_SESSION_ID_KEY, uuid = false }): string {
	const sessionId = sessionStorage.getItem(storageSessionIdKey);

	if (!sessionId) {
		sessionStorage.setItem(storageSessionIdKey, uuid ? generateRandomGUID() : generateRandomId());
	}

	return sessionStorage.getItem(storageSessionIdKey) as string;
}

export function getSessionId(args?: { storageSessionIdKey?: string }) {
	const { storageSessionIdKey } = args || {};

	return sessionStorage.getItem(storageSessionIdKey || STORAGE_SESSION_ID_KEY) as string;
}
